import React, { useEffect, useState } from 'react';
import { FileUploader, Input, InputWithSymbol, Multiselect } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import { STORAGE_KEYS } from 'utils/constants';
import { CoKitchenType } from 'models/cokitchen.model';
import { AddRiderFormType } from '.';
import { RiderFieldType } from './types';

type locationType = {
  text: string;
  value: string;
};

const AddRiderForm = ({
  handleAddRiders,
  handleDelete,
  formData
}: {
  handleAddRiders: (e: any, i: any, field: RiderFieldType) => void;
  formData: AddRiderFormType;
  handleDelete?: (i: number) => void;
}) => {
  const { riders } = formData;
  const [locations, setLocations] = useState<locationType[]>([]);
  const cokitchenArray: CoKitchenType[] = JSON.parse(
    localStorage.getItem(STORAGE_KEYS.COKITCHEN_LIST) ?? '[]'
  );

  const options: locationType[] = [];

  const getLocationOptions = (item: CoKitchenType[]) => {
    for (let i = 0; i < item?.length; i++) {
      if (item)
        options.push({
          value: item[i]?.id,
          text: item[i]?.name
        });
    }
  };

  useEffect(() => {
    getLocationOptions(cokitchenArray);
  }, [cokitchenArray]);

  useEffect(() => {
    if (options) setLocations(options);
  }, []);

  const getPolygonOptions = (id: string) => {
    const cokitchen = cokitchenArray.find((cokitchen) => cokitchen.id === id);
    const cokitchenPolygons = cokitchen?.cokitchen_polygons;
    return (
      cokitchenPolygons?.map((polygon) => ({
        value: polygon.id,
        text: polygon.name
      })) || []
    );
  };
  const genderOptions = [
    {
      value: 'Male',
      text: 'Male'
    },
    {
      value: 'Female',
      text: 'Female'
    }
  ];
  return (
    <div className='space-y-8'>
      {riders.map(
        (
          {
            first_name,
            email,
            last_name,
            phone_number,
            profile_image,
            user_gender,
            cokitchen_id,
            cokitchen_polygon_ids
          },
          i
        ) => (
          <div key={i} className='space-y-2 relative pb-4'>
            <div className='grid grid-cols-2 gap-2'>
              <Input
                name='first_name'
                label='First Name'
                placeholder='Jeffery'
                small
                onChange={(e) => handleAddRiders(e, i, 'first_name')}
                value={first_name}
              />
              <Input
                name='last_name'
                label='Last Name'
                placeholder='Williams'
                small
                onChange={(e) => handleAddRiders(e, i, 'last_name')}
                value={last_name}
              />
            </div>
            <Input
              name='email'
              label='Email'
              placeholder="Rider's email"
              small
              onChange={(e) => handleAddRiders(e, i, 'email')}
              value={email}
            />
            <InputWithSymbol
              symbol='flag'
              name='phone_number'
              label='Mobile no.'
              placeholder='+234 0124 422 333'
              small
              onChange={(e) => handleAddRiders(e, i, 'phone_number')}
              value={phone_number}
            />
            <div>
              <label className='font-medium'>Gender</label>
              <Multiselect
                placeholder='Select Gender'
                isSingle
                values={user_gender ? [user_gender] : []}
                options={genderOptions}
                onChange={(e) => {
                  handleAddRiders(e[0], i, 'user_gender');
                }}
              />
            </div>
            <div
              className={`pt-3 ${i !== riders.length - 1 && 'border-b border-b-gray-border pb-8'}`}>
              <label className='font-medium'>Add rider image</label>
              <FileUploader
                token={localStorage.getItem(STORAGE_KEYS.TOKEN) as string}
                fileUrls={profile_image ? [profile_image] : []}
                setFileUrls={(files) => handleAddRiders(files[0], i, 'profile_image')}
              />
            </div>
            <div>
              <label className='font-medium'>Which cokitchen will this rider operate at</label>
              <Multiselect
                placeholder='Cokitchen Lekki'
                isSingle
                values={cokitchen_id ? [cokitchen_id] : []}
                options={locations}
                onChange={(e) => {
                  handleAddRiders(e[0], i, 'cokitchen_id');
                }}
              />
            </div>
            {cokitchen_id && (
              <div>
                <label className='font-medium'>Which polygons will he be plotting</label>
                <Multiselect
                  placeholder='Jakande - Chevron'
                  values={cokitchen_polygon_ids}
                  options={getPolygonOptions(cokitchen_id)}
                  onChange={(e) => {
                    handleAddRiders(e, i, 'cokitchen_polygon_ids');
                  }}
                />
              </div>
            )}
            {riders.length > 1 && (
              <DeleteIcon
                className='bg-red-1 text-red-5 p-[5px] w-6 h-6 rounded-md hover:bg-red-2 transition-all cursor-pointer absolute -top-3 right-0'
                onClick={() => handleDelete?.(i)}
              />
            )}
          </div>
        )
      )}
    </div>
  );
};

export default AddRiderForm;
